import { UPDATE_HOUSE_LOGO, UPDATE_ORGANIZATION_LOGO, UPLOAD_JOB_FILES, UPLOAD_PRODUCT_FILE } from "../graphql"

// This is to pass name to InputFile component so it can extract data from mutation
export const FileUploadMutationList = {
    updateHouseLogo: "updateHouseLogo",
    updateOrganizationLogo: "updateOrganizationLogo",
    uploadJobFiles: "uploadJobFiles",
    uploadProductFile: "uploadProductFile"
}

export const FileUploadMutations = {
    [FileUploadMutationList.updateHouseLogo]: UPDATE_HOUSE_LOGO,
    [FileUploadMutationList.updateOrganizationLogo]: UPDATE_ORGANIZATION_LOGO,
    [FileUploadMutationList.uploadJobFiles]: UPLOAD_JOB_FILES,
    [FileUploadMutationList.uploadProductFile]: UPLOAD_PRODUCT_FILE
}